import styled from 'styled-components';
import { colours } from 'themes/default';

const SelectedSeat = styled.div`
  border: 1px solid ${colours.Greyscale.CharcoalGrey};
  border-radius: 30px;
  background-color: ${(props) => (props.selected && !props.disabled ? colours.Greyscale.SilverGrey : colours.Greyscale.White)};
  cursor: ${(props) => (!props.disabled ? 'pointer' : 'auto')};
  pointer-events: ${(props) => (!props.disabled ? 'auto' : 'none')};
  width: 50%;
`;

const StyledSeatSelectionWrapper = styled.div`
  background-color: ${colours.Greyscale.MistGrey};
  padding: 5px;
  height: ${(props) => props.numberOfRows * 40}px;
`;

const StyledSeat = styled.div`
  div {
    display: inline-block;
  }

  div:nth-child(2) {
    padding: 5px;
    text-align: center;
  }

  .seat-index {
    width: 25%;
    text-align: right;
    padding-right: 5px;
    color: ${colours.Greyscale.CharcoalGrey};
  }
`;

export { SelectedSeat, StyledSeatSelectionWrapper, StyledSeat };
